import React, { useState, useEffect } from "react";
import UserSidebar from "./UserSidebar";
import UserHeader from "./UserHeader";
import { BASE_URL } from "../api_call";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";

export default function DataBreach() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    task_id: "",
    task_action_date: "",
    task_reminder_days: 1,
    task_escalation_email: "",
    task_escalation_reminder_days: 0,
  });

  const [originalData, setOriginalData] = useState(null); // 🔹 store original values
  const [successMsg, setSuccessMsg] = useState("");
  const [errors, setErrors] = useState({});

  // 🔹 Prefill data from localStorage
  useEffect(() => {
    const taskId = localStorage.getItem("taskId");
    if (!taskId) return;

    const data = {
      task_id: taskId,
      task_action_date: localStorage.getItem("taskActionDate") || "",
      task_reminder_days: Number(localStorage.getItem("taskReminderDays") || 1),
      task_escalation_email: localStorage.getItem("taskEscalationEmail") || "",
      task_escalation_reminder_days: Number(localStorage.getItem("taskEscalationReminderDays") || 0),
    };

    setFormData(data);
    setOriginalData(data); // 🔹 save original
  }, []);

  // 🔹 Input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name.toLowerCase().includes("days") ? Number(value) : value,
    }));
    setSuccessMsg("");
    setErrors({});
  };

  // 🔹 Check if any field is changed
  const isEdited = () => {
    if (!originalData) return false;
    return (
      formData.task_action_date !== originalData.task_action_date ||
      formData.task_reminder_days !== originalData.task_reminder_days ||
      formData.task_escalation_email !== originalData.task_escalation_email ||
      formData.task_escalation_reminder_days !== originalData.task_escalation_reminder_days
    );
  };

  // 🔹 Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setErrors({});

    const { task_id, task_action_date, task_reminder_days, task_escalation_email, task_escalation_reminder_days } = formData;
    if (!task_id) {
      setErrors({ api: "Task ID missing" });
      return;
    }

    try {
      const token = localStorage.getItem("access_token");
      const res = await fetch(`${BASE_URL}/data-breach/edit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          task_id,
          task_action_date,
          task_reminder_days,
          task_escalation_email,
          task_escalation_reminder_days,
        }),
      });

      const data = await res.json();
      if (res.status === 200) {
        setSuccessMsg("✅ Data breach report updated successfully");
        setTimeout(() => navigate("/data_breach-info"), 1000);
      } else {
        setErrors({ api: data.error || "❌ Update failed" });
      }
    } catch (err) {
      console.error(err);
      setErrors({ api: "❌ Update failed" });
    }
  };

  return (
    <div className="add-user">
      <UserSidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <UserHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="form-container">
        <h2>Edit Data Breach</h2>

        {errors.api && <div className="login-error">{errors.api}</div>}
        {successMsg && <div className="success-msg">{successMsg}</div>}

        <form onSubmit={handleSubmit} className="add-user-form">
          <label>
            Action Date
            <input
              type="date"
              name="task_action_date"
              value={formData.task_action_date}
              onChange={handleInputChange}
            />
          </label>

          <label>
            Reminder Days
            <input
              type="number"
              name="task_reminder_days"
              min="1"
              value={formData.task_reminder_days}
              onChange={handleInputChange}
            />
          </label>

          <label>
            Escalation Email
            <input
              type="email"
              name="task_escalation_email"
              value={formData.task_escalation_email}
              onChange={handleInputChange}
            />
          </label>

          <label>
            Reminder Before Escalation (Days)
            <input
              type="number"
              name="task_escalation_reminder_days"
              min="0"
              value={formData.task_escalation_reminder_days}
              onChange={handleInputChange}
            />
          </label>

          <button type="submit" className="submit-btn" disabled={!isEdited()}>
            Update Report
          </button>
        </form>
      </div>
    </div>
  );
}